window.specTabs = function specTabs() {

    if ($('.specTabs').length) {
        if ($(window).width() < window.breakpoints.mobile && !$('.specTabs').hasClass('hasTabs')) {
            $('.specTabs').mtcTabs({
                breakpoint: 0
            });
            $('.specTabs').addClass('hasTabs');
        } else if ($(window).width() > window.breakpoints.mobile && $('.specTabs').hasClass('hasTabs')) {
            $('.specTabs').data('plugin_mtcTabs').destroy();
            $('.specTabs').removeClass('hasTabs');
        }
    }
}

$(document).ready(function () {
    'use strict';

    specTabs();
});

$(window).on('resize', debouncer(function (e) {
    'use strict';

    specTabs();
}));